import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReturnToState {
  pathname: string;
}

const initialState: ReturnToState = {
  pathname: '/'
};

const ReturnToSlice = createSlice({
  name: 'returnTo',
  initialState,
  reducers: {
    setReturnTo: (state: ReturnToState, action: PayloadAction<string>) => {
      state.pathname = action.payload;
    }
  }
});

export const { setReturnTo } = ReturnToSlice.actions;
export default ReturnToSlice.reducer;
